import classNames from 'classnames'

import Container from '~/components/atoms/Container/Container'
import GenreCard from '~/components/atoms/GenreCard/GenreCard'
import Spacer, { SpacerSizes } from '~/components/atoms/Spacer/Spacer'
import Text, { TextSizes } from '~/components/atoms/Text/Text'
import type { TSearchAnalystEventProps } from '~/services/elastic/analyst'
import type { ProcessedSettings } from '~/services/sanity/siteSettings'

import styles from './GenreSlider.module.css'

export interface GenreSliderProps {
  genres: ProcessedSettings['genres']
  title: string
  testID?: string
  borderTop?: boolean
  searchInsightsEvent?: TSearchAnalystEventProps
}

export default function GenreSlider({
  genres,
  title,
  testID,
  borderTop = false,
  searchInsightsEvent,
}: GenreSliderProps) {
  return (
    <div
      className={classNames(styles.base, borderTop && styles.borderTop)}
      data-testid={testID}
      style={{ overflow: 'hidden' }}
    >
      <Container>
        <Text size={TextSizes.primaryTitleLrg}>{title}</Text>
        <Spacer size={SpacerSizes.md} />
        <div className={styles.cards}>
          {genres.map((genre, i) => {
            return (
              <GenreCard
                {...genre}
                key={`genre-slide-${i}`}
                searchInsightsEvent={searchInsightsEvent}
              />
            )
          })}
        </div>
      </Container>
    </div>
  )
}
